import moment from 'moment';

/**
 * Declaración de los filtros de la grilla de Facturas para <GridFilterPanel />.
 *
 * Vive en su propio módulo porque lo consumen DOS lados: el panel (para renderizar)
 * y FacturasGrid (para calcular el query por defecto con las mismas reglas de
 * serialización). Antes esa lista estaba duplicada en los dos archivos.
 */

export const FACTURAS_FILTROS_STORAGE_KEY = 'FacturasGrid_filtros';

/**
 * Valores por defecto: rango de fecha de creación = último mes, para que la primera
 * petición ya vaya filtrada (objetivo de performance de VEC-3413).
 * Es una función, no una constante, porque "hoy" cambia entre sesiones.
 */
export const getFacturasFilterDefaults = () => ({
	fechaCreacionDesde: moment().subtract(1, 'month').format('YYYY-MM-DD'),
	fechaCreacionHasta: moment().format('YYYY-MM-DD'),
});

/**
 * @param flags.mostrarNroPrefacturacion  facturas.prefacturacion.habilitado
 * @param flags.mostrarMetodoDePago       tickets.metodoPago.habilitado + permiso METODOS_PAGO_LISTAR
 */
export const buildFacturasFilterFields = (flags) => {
	const opciones = flags || {};

	return [
		{
			name: 'fechaCreacionDesde',
			type: 'date',
			messageId: 'facturasGrid.filtros.fecha_creacion_desde',
			label: 'Fecha creación desde',
		},
		{
			name: 'fechaCreacionHasta',
			type: 'date',
			messageId: 'facturasGrid.filtros.fecha_creacion_hasta',
			label: 'Fecha creación hasta',
		},
		{
			name: 'nroPrefacturacion',
			type: 'text',
			messageId: 'facturasGrid.filtros.nro_prefacturacion',
			label: 'Nro. Prefacturación',
			visible: opciones.mostrarNroPrefacturacion === true,
		},
		{
			name: 'gerenciador',
			type: 'multiselect',
			messageId: 'facturasGrid.filtros.gerenciador',
			label: 'Gerenciador',
		},
		{
			name: 'tipo',
			type: 'text',
			messageId: 'facturasGrid.filtros.tipo',
			label: 'Tipo',
		},
		{
			name: 'puntoDeVenta',
			type: 'text',
			messageId: 'facturasGrid.filtros.punto_de_venta',
			label: 'Punto de Venta',
		},
		{
			name: 'numero',
			type: 'text',
			messageId: 'facturasGrid.filtros.numero',
			label: 'Número',
		},
		{
			// El backend parsea este filtro como d/m/Y (FacturasRepository::grid,
			// case 'fecha'), distinto del rango de fecha de creación.
			name: 'fecha',
			type: 'date',
			dateOutputFormat: 'DD/MM/YYYY',
			messageId: 'facturasGrid.filtros.fecha',
			label: 'Fecha',
		},
		{
			name: 'metodoDePago',
			type: 'multiselect',
			messageId: 'facturasGrid.filtros.metodo_de_pago',
			label: 'Método de pago',
			visible: opciones.mostrarMetodoDePago === true,
		},
		{
			name: 'quincena',
			type: 'multiselect',
			messageId: 'facturasGrid.filtros.quincena',
			label: 'Quincena',
		},
		{
			name: 'mes',
			type: 'multiselect',
			messageId: 'facturasGrid.filtros.mes',
			label: 'Mes',
		},
		{
			name: 'anio',
			type: 'text',
			messageId: 'facturasGrid.filtros.anio',
			label: 'Año',
		},
		{
			name: 'importe',
			type: 'text',
			messageId: 'facturasGrid.filtros.importe',
			label: 'Importe',
		},
		{
			name: 'estado',
			type: 'multiselect',
			messageId: 'facturasGrid.filtros.estado',
			label: 'Estado',
		},
	];
};
